module.exports = __webpack_public_path__ + "img/gongzhonghao.9cbd0ccf.png";